
{
  "labels": {
    "unknown": "Unknown Page"
  },
  "actions": {
    "add-page": "Add Page"
  }
}
